export const getCurrentUser = () => {
  let currentUser = {}
  try {
    const info = JSON.parse(localStorage.getItem('currentUser') || '{}')
    currentUser = info
  } catch (error) {
    console.log(error)
  }
  return currentUser
}

export const getToken = () => {
  return localStorage.getItem('token')
}

const permissionBtn = ['logout']

export const generatePermission = (data: any) => {
  const permissions: any = {
    pages: {},
    btns: {},
  }
  const modules = Object.keys(data)

  for (const name of modules) {
    const btns: any = []
    const pages = data[name].reduce((acc: any, curr: any) => {
      acc.push(name + '/' + curr.powerName + '/*')
      if (curr.type === 'button') {
        btns.push(curr.powerName)
      }
      return acc
    }, [])
    if (data[name].length) {
      pages.push(name)
    }

    permissions.pages[name] = pages
    permissions.btns[name] = btns
  }
  return permissions
}
